import { CourseModel } from "@/models/CourseModels";
import { BaseRepo } from "./base/BaseRepo";



// src/repos/RoundRepo.ts
/**
 * Repository for models in the rounds collection
 */
export class CoursesRepo extends BaseRepo<CourseModel> {
    protected collectionName = 'courses';
    protected cacheKeyPrefix = 'course_';

}